import React, { useEffect, useState } from 'react';
import { withRouter } from '../../common/utils/NavigationWrapper';
import PageContainer from '../../common/components/Page/PageContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import ReportRendererContainer from '../../common/components/ReportRenderer/ReportRendererContainer';
import './ManufacturingDashboardDetails.css';
import DeviceSummary from './components/DeviceSummary';
import { getInstrumentDetails } from './../InstrumentDetails/InstrumentDetails.actions';
import CircularProgress from '@mui/material/CircularProgress';

const ManufacturingDashboardDetails = (props) => {
  const { params } = props;
  const instrumentSerialnumber = params.id;

  const [instrument, setInstrument] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getInstrumentDetails(instrumentSerialnumber)
      .then((res) => setInstrument(res.body))
      .then(() => {
        setLoading(false);
      });
  }, []);

  return (
    <PageContainer pageName="manufacturing-dashboard-details">
      <PermissionsCheck
        appliedToPage={true}
        permission={PermissionsEnum.VIEW_MANUFACTURING_DASHBOARD}
      >
        {loading ? (
          <CircularProgress />
        ) : (
          <div>
            <div className="manufacturing-dashboard-details__left">
              <DeviceSummary instrument={instrument} />
            </div>
            <div className="manufacturing-dashboard-details__right">
              <ReportRendererContainer />;
            </div>
          </div>
        )}
      </PermissionsCheck>
    </PageContainer>
  );
};

export default withRouter(ManufacturingDashboardDetails);
